import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {admin_role_id, profile_url, super_admin_role_id} from "../../constant";
import {NotificationCountService} from "../../services/adminServices";
import {useSelector} from "react-redux";
import CustomUserProfile from "../../CustomComponents/CustomUserProfile";

const DashboardHeader = ({toggleSidebar, isDisable}) => {
	const location = useLocation();
	// const firstName = localStorage.getItem("first_name") || "";
	// const lastName = localStorage.getItem("last_name") || "";
	const [notificationsCount, setNotificationsCount] = useState(0);

	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [role, setRole] = useState(null);
	const [userProfile, setUserProfile] = useState(null);

	useEffect(() => {
		const role = localStorage.getItem("role");
		setRole(role);
	}, []);

	useEffect(() => {
		const loadUserData = () => {
			setFirstName(localStorage.getItem("first_name") || "");
			setLastName(localStorage.getItem("last_name") || "");
			setUserProfile(localStorage.getItem("profile_image") || "");
		};

		// Load initial data
		loadUserData();

		// Listen for localStorage changes
		const handleStorageChange = (e) => {
			if (e.key === "first_name" || e.key === "last_name") {
				loadUserData();
			}
		};

		// Listen for custom events (for same-tab updates)
		const handleCustomStorageChange = () => {
			loadUserData();
		};

		window.addEventListener("storage", handleStorageChange);
		window.addEventListener("localStorageUpdate", handleCustomStorageChange);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
			window.removeEventListener("localStorageUpdate", handleCustomStorageChange);
		};
	}, []);

	useEffect(() => {
		const getCount = async () => {
			const response = await NotificationCountService();
			if (response?.status) {
				setNotificationsCount(Number(response?.data));
			} else {
				setNotificationsCount(Number(0));
			}
		};

		getCount();
	}, [location.pathname]);

	const {pageHerder} = useSelector((state) => state?.common);

	// Add new useEffect to listen for notification count updates
	useEffect(() => {
		const handleNotificationCountUpdate = () => {
			const getCount = async () => {
				const response = await NotificationCountService();
				if (response?.status) {
					setNotificationsCount(Number(response?.data));
				} else {
					setNotificationsCount(Number(0));
				}
			};
			getCount();
		};

		// Listen for custom event when notification count should be updated
		window.addEventListener("notificationCountUpdate", handleNotificationCountUpdate);

		return () => {
			window.removeEventListener("notificationCountUpdate", handleNotificationCountUpdate);
		};
	}, []);

	const userRole = localStorage.getItem("role") == super_admin_role_id ? "Super Admin" : localStorage.getItem("role") == admin_role_id ? "Admin" : "Contractor";

	// Get initials for avatar
	const getInitials = () => {
		if (firstName && lastName) {
			return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
		} else if (firstName) {
			return firstName.charAt(0).toUpperCase();
		}
		return "U";
	};

	const verification = localStorage.getItem("verified");
	const badge = localStorage.getItem("badge");
	const trusted = localStorage.getItem("trusted");

	return (
		<header className="dashboard-header">
			<div className="header-left">
				<button className="mobile-menu-btn d-lg-none" onClick={toggleSidebar}>
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</button>
				<h1 className="page-title">{role === super_admin_role_id || role === admin_role_id ? "Admin" : "Contractor"} Dashboard</h1>
			</div>

			<div className="header-right">
				<div className="header-actions">
					{/* Notifications */}
					<div className="notification-wrapper">
						{/* <Link to="/admin-dashboard/notifications" className="notification-btn"> */}
						<Link
							aria-disabled={isDisable}
							to={role === super_admin_role_id || role === admin_role_id ? "/admin-dashboard/notifications" : "/contractor-dashboard/notifications"}
							className={`notification-btn ${isDisable ? "disabled" : ""}`}
							onClick={(e) => {
								if (isDisable) {
									e.preventDefault();
								}
							}}>
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
							{notificationsCount !== 0 && <span className="notification-badge">{notificationsCount}</span>}
						</Link>
					</div>

					{/* User Profile */}
					<Link
						aria-disabled={isDisable}
						to={role === super_admin_role_id || role === admin_role_id ? "/admin-dashboard/my-profile" : "/contractor-dashboard/my-profile"}
						className={`user-profile ${isDisable ? "disabled" : ""}`}
						onClick={(e) => {
							if (isDisable) {
								e.preventDefault();
							}
						}}>
						<div className=" position-relative">
							<CustomUserProfile
								user={{
									first_name: firstName,
									last_name: lastName,
									profile_image: userProfile,
								}}
							/>
							{/* {verification === "true" && (
								<svg
									className="position-absolute"
									style={{
										top: "-8px",
										right: "-9px",
										background: "#FFF",
										borderRadius: "100px",
									}}
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 24 24">
									<path
										// fill="#ffc107"
										fill="#0d6efd"
										d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
									/>
								</svg>
							)}
							{badge == "true" && (
								<div
									className="position-absolute"
									style={{
										top: "14px",
										right: "32px",
										background: "#FFF",
										borderRadius: "100px",
									}}>
									<img src={`${process.env.PUBLIC_URL}/img/favicon.png`} width={20} />
								</div>
							)} */}

							{verification == "true" && (
								<svg
									className="position-absolute"
									style={{
										top: "-8px",
										right: "-9px",
										background: "#FFF",
										borderRadius: "100px",
									}}
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 24 24">
									<path
										// fill="#ffc107"
										fill="#0d6efd"
										d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
									/>
								</svg>
							)}
							{badge == "true" && (
								<div
									className="position-absolute"
									style={{
										top: "14px",
										right: "35px",
										background: "#FFF",
										borderRadius: "100px",
									}}>
									<img src={`${process.env.PUBLIC_URL}/img/favicon.png`} width={20} />
								</div>
							)}
							{trusted == "true" && (
								<svg
									className="position-absolute"
									style={{
										top: "22px",
										right: "-14px",
										background: "#FFF",
										borderRadius: "100px",
									}}
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 24 24">
									<path
										fill="#28A745"
										d="M12 13q1.45 0 2.475-1.025T15.5 9.5t-1.025-2.475T12 6T9.525 7.025T8.5 9.5t1.025 2.475T12 13m0 9q-3.65-.925-5.825-4T4 11.1V5l8-3l8 3v6.1q0 3.825-2.175 6.9T12 22m0-2.1q1.475-.475 2.613-1.487t1.987-2.288q-1.075-.55-2.238-.837T12 15t-2.363.288t-2.237.837q.85 1.275 1.988 2.288T12 19.9"
									/>
								</svg>
							)}
						</div>

						<div className="user-info d-none d-md-block">
							<div className="user-name text-capitalize">
								{firstName} {lastName}
							</div>
							<div className="user-role text-capitalize">{userRole}</div>
						</div>
					</Link>
				</div>
			</div>
		</header>
	);
};

export default DashboardHeader;
